import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "447",
  "slug": "most-densely-populated-countries-in-the-world",
  "title": "Population Density: Comparing Countries Without Hiding the Gaps",
  "excerpt": "A national average measures people per area; it does not describe every neighbourhood.",
  "date": "2026-06-15",
  "category": "Geography",
  "image": "https://images.unsplash.com/photo-1499669404910-ba8b35824a3c?ixid=M3w5NjY4NzN8MHwxfHNlYXJjaHwxfHxjcm93ZGVkJTIwY2l0eSUyMGFlcmlhbHxlbnwxfDB8fHwxNzgxNTEwODc4fDA&ixlib=rb-4.1.0&w=800&q=80&fit=crop",
  "readTime": "2 min",
  "author": "EarthGuessr Team",
  "content": [
    {
      "type": "paragraph",
      "text": "Population density divides a population by an area. The World Bank indicator uses people per square kilometre of land area. Check that definition before comparing it with a figure that includes inland water or uses a different boundary."
    },
    {
      "type": "paragraph",
      "text": "Small urban states such as Monaco and Singapore illustrate high national density. Bangladesh provides a different comparison: a much larger territory with an extensive settled and cultivated plain. A list mixing sovereign states, dependent territories, and metropolitan areas needs to state that scope before it can be called a ranking."
    },
    {
      "type": "heading",
      "text": "Build a comparable table"
    },
    {
      "type": "paragraph",
      "text": "Take the population, land area, and reference year from one consistent source. If a country's latest value comes from another year, show the year beside it rather than calling the entire table current. Avoid categories such as “large country” unless you define the threshold."
    },
    {
      "type": "heading",
      "text": "The average hides the distribution"
    },
    {
      "type": "paragraph",
      "text": "A hypothetical country with ten million people and 100,000 square kilometres of land averages 100 people per square kilometre. That does not mean each square kilometre contains 100 residents. They may be concentrated in a few cities, leaving much of the country sparsely settled."
    },
    {
      "type": "paragraph",
      "text": "A satellite image shows buildings and land cover, not the number of residents inside them. Use a population distribution dataset to investigate where people live, then compare that pattern with the imagery. Dense roof coverage alone cannot tell you the national average."
    }
  ],
  "sources": [
    {
      "title": "World Bank: population-density definition and comparability",
      "url": "https://databank.worldbank.org/metadataglossary/world-development-indicators/series/EN.POP.DNST"
    },
    {
      "title": "World Bank: population density data",
      "url": "https://data.worldbank.org/indicator/EN.POP.DNST"
    }
  ],
  "relatedSlugs": [
    "most-populous-countries-in-the-world-ranked",
    "most-populous-cities-in-the-world"
  ]
};
